import React, { FC, useState } from 'react'

import { openInNewTab } from '../Utils'
import { helpURL } from '../App.config'
import { simMod } from '../Module.config'

import { AboutDialog } from './AboutDialog'
import Menu, { MenuItem } from './Menu'

type Props = {
    visible: boolean
    hideMenu: () => void
}

const HelpMenu: FC<Props> = ({ visible, hideMenu }: Props) => {
    const [showAbout, setShowAbout] = useState(false)

    const helpClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault()
        openInNewTab(simMod.moduleHelpURL ? simMod.moduleHelpURL : helpURL)
        hideMenu()
    }

    const aboutClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault()
        setShowAbout(true)
        hideMenu()
    }

    return (
        <div>
            <Menu
                title={'Help Options'}
                visible={visible}
                onOutsideClick={hideMenu}
            >
                <MenuItem
                    text='Program Help'
                    onClick={helpClick}
                />
                <MenuItem
                    text='About this module'
                    onClick={aboutClick}
                />
            </Menu>
            <AboutDialog visible={showAbout} onHide={() => setShowAbout(false)} />
        </div>
    )
}

export default HelpMenu